import styled from 'styled-components';

const TitleStyled = styled.span`
  display: -webkit-box;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3em;
  max-height: 2.6em;
`;

export default TitleStyled;
